import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import "../style/LeadPopup.css";

const LeadPopup = ({ carName, type, onClose }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    city: "",
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(
        collection(db, type === "alert" ? "launchAlerts" : "offerLeads"),
        {
          ...form,
          carName,
          leadType: type,
          createdAt: Timestamp.now(),
        }
      );

      setSubmitted(true);
    } catch (error) {
      console.error("Firestore Error:", error);
    }

    setLoading(false);
  };

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        {!submitted ? (
          <>
            <button className="popup-close" onClick={onClose}>
              ✕
            </button>

            <h3>
              {type === "alert"
                ? "Get Launch Alert"
                : "Get January Offers"}
            </h3>

            <p className="popup-car">{carName}</p>

            <form onSubmit={handleSubmit} className="popup-form">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={form.name}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number"
                value={form.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="city"
                placeholder="City"
                value={form.city}
                onChange={handleChange}
                required
              />

              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </>
        ) : (
          <div className="success-state">
            <div className="success-icon">✅</div>
            <h3>Submission Successful!</h3>

            <p>
              {type === "alert"
                ? "We’ll notify you as soon as the car is launched."
                : "Our team will contact you with the best offers shortly."}
            </p>

            <button className="success-btn" onClick={onClose}>
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadPopup;
